"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EntityTooltipContent;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _EntityTooltipContentModule = _interopRequireDefault(require("./EntityTooltipContent.module.scss"));

var _BorderedBox = _interopRequireDefault(require("../../common/BorderedBox/BorderedBox"));

var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));

var _components = require("./components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function EntityTooltipContent(_ref) {
  var entity = _ref.entity,
      entityType = _ref.entityType,
      viewingCharacter = _ref.viewingCharacter,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var loadingSpinner = /*#__PURE__*/_react.default.createElement("div", {
    className: _EntityTooltipContentModule.default.spinner
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    width: 60,
    duration: 0.4
  }));

  var content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

  switch (entityType) {
    case "item":
      content = /*#__PURE__*/_react.default.createElement(_components.ItemTooltipContent, {
        item: entity,
        viewingCharacter: viewingCharacter
      });
      break;

    case "classSkill":
      content = /*#__PURE__*/_react.default.createElement(_components.ClassSkillTooltipContent, {
        skill: entity,
        viewingCharacter: viewingCharacter
      });
      break;

    case "craftingSkill":
      content = /*#__PURE__*/_react.default.createElement(_components.CraftingSkillTooltipContent, {
        skill: entity,
        viewingCharacter: viewingCharacter
      });
      break;

    case "classSkillCombo":
      content = /*#__PURE__*/_react.default.createElement(_components.ClassSkillComboTooltipContent, {
        skillCombo: entity,
        viewingCharacter: viewingCharacter
      });
      break;

    default:
      throw new Error("Unknown skill type '".concat(JSON.stringify(entityType), "' passed into SkillTooltip."));
  } // TODO: the timeout should be replaced with fetch


  setTimeout(function () {
    setIsLoading(false); // TODO: debounce mouseOver ?
  }, 250);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_EntityTooltipContentModule.default.entityTooltip, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_BorderedBox.default, {
    type: "TOOLTIP",
    className: _EntityTooltipContentModule.default.borderedBox,
    contentClassName: _EntityTooltipContentModule.default.content
  }, isLoading && loadingSpinner, !isLoading && content));
}